 import React,{useState, useContext} from 'react'
import Contex from '../Context/CreateContext';

const  AddResearchItem = () => {
    const contex = useContext(Contex)
    const {handleAddResearchItem, fetchResearchItemData, showAlert} = contex
  const [ AddResearchItemData, setAddResearchItemData] = useState({title:"", desc:"", catg:"",authors:"", url:"", date:""});
// const { AddResearchItemData, set AddResearchItemData} = useState({title:"", desc:"", catg:"", url:""})
const [successMsg, setSuccessMsg] = useState("");
const [failMsg, setFailsMsg] = useState("");

const onChange = (e)=>{
  const {name, value} = e.target
 
  setAddResearchItemData({... AddResearchItemData, [name]:value})
}
const handleformSubmit =async(e)=>{
  e.preventDefault()
const  {title, desc, catg, url , date, authors} =  AddResearchItemData

   const res = await  handleAddResearchItem(title, desc, catg, url , date, authors)
   const json = await res.json()

  if(!res.ok){
showAlert("danger", json.msg )
}else{
  setAddResearchItemData( {title:"", desc:"", catg:"",authors:"", url:"", date:""})
  await fetchResearchItemData()
    showAlert("success", json.msg )

  }
  

 
}
  return (
<div className='container mx-auto mt-20  bg-gray-50 dark:bg-yellow-100 text-black '>
 
  <div className="flex flex-col items-center justify-center  lg:py-0">
      <a className="flex items-center mb-6 text-2xl font-semibold text-gray-900 dark:text-black no-underline">
        <img className="w-8 h-8 mr-2" src="https://cdn.iconscout.com/icon/premium/png-256-thumb/note-plus-3199351-2665696.png" alt="logo" />
   Add new Research  paper
      </a>
      </div>
      <div className='h-4 '>
          {failMsg && <p className='text-white-500   bg-red-300 rounded text-center '>{failMsg}</p>}

</div>
        <div className='h-4 '>
          {successMsg && <p className='text-white-500   bg-green-300 rounded text-center '>{successMsg}</p>}

</div>
      <form className=" md:p-5 pt-0 space-y-4 md:space-y-6" onSubmit={handleformSubmit} >
      <div>
              <label htmlFor="title" className="block mb-2 text-sm font-medium text-gray-900 dark:text-black">Title  <small className='text-red-500 text-xl' > *</small></label>
              <input type="text" name="title" id="title" value={AddResearchItemData.title} onChange={onChange} className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-secondary-600 focus:border-secondary-500  w-full p-2.5 dark:bg-gray-500  dark:border-gray-600 dark:placeholder-gray-300 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="XYZ"  />
            </div>
            <div>
              <label htmlFor="desc" className="block mb-2 text-sm font-medium text-gray-900 dark:text-black">Description</label>
              <textarea cols="30" rows="5" name ="desc" onChange={onChange}   value={AddResearchItemData.desc} className='"bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-secondary-600 focus:border-secondary-500 block w-full p-2.5 dark:bg-gray-500 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'></textarea>
            
            </div>
           
            <div>
              <label htmlFor="password" className="block mb-2 text-sm font-medium text-gray-900 dark:text-black">Category   <small className='text-red-500 text-xl' > *</small></label>
             <select onChange={onChange}  name = "catg"   value={AddResearchItemData.catg}   className='bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-secondary-600 focus:border-secondary-500 block w-full p-2.5  dark:bg-gray-500 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500' >
                <option className='text-center' >--Select category--</option>
                <option value="googleScholar">Google Scholar</option>
                <option value="researchGate" >Research Gate</option>
                <option value="newsPaper" >News Paper</option>
             </select>
            </div>

            <div>
              <label htmlFor="authors" className="block mb-2 text-sm font-medium text-gray-900 dark:text-black">Authors  </label>
              <input type="text" name="authors" id="authors"  value={AddResearchItemData.authors} onChange={onChange} className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-secondary-600 focus:border-secondary-500  w-full p-2.5 dark:bg-gray-500 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="XYZ"  />
            </div>

             <div className='w-full md:flex md:flex-wrap'>

            <div className=' w-full md:w-1/2  '>
              <label htmlFor="url" className="block mb-2 text-sm font-medium text-gray-900 dark:text-black">Url</label>
              <input type="text" name="url"  onChange={onChange}   value={AddResearchItemData.url}    id="text" placeholder="https://xyz.com" className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5  dark:bg-gray-500 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"  />
            </div>
            <div className=' w-full md:w-1/2   pl-5'>
              <label htmlFor="url" className="block mb-2 text-sm font-medium text-gray-900 dark:text-black">Date</label>
              <input type="date" name="date"  onChange={onChange}   value={AddResearchItemData.date}    id="date" placeholder="" className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-500 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"  />
            </div>
            </div>
         <div className="flex justify-center items-center ">


            <button type="submit" className="  w-1/3 text-black bg-yellow-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">Add</button>
            
         </div>
           
          
     
      </form>
           

  </div>

  )
}

export default  AddResearchItem